/**
 * cancelamento.ts — distingue cancelamento do navegador (troca de tela,
 * fechar aba, nova navegação antes da resposta terminar) de erro de verdade.
 *
 * Task wdwxndz6m6, 06/10/2026. Medido em produção (últimos 30 dias, 10
 * ocorrências/dia em média, última em 04/10): 125 ocorrências de
 * "signal is aborted without reason" / "The user aborted a request."
 * entrando como `error.promise` — toda rejeição de promise por
 * `AbortController` (fetch/React Query cancelado ao sair da tela antes da
 * resposta) virava "erro" na telemetria e no relatório diário, sem nenhum
 * defeito por trás.
 */

const PADROES_DE_CANCELAMENTO: RegExp[] = [
  /signal is aborted/i,
  /AbortError/i,
  /The user aborted/i,
]

/** O motivo de uma rejeição/erro é cancelamento do navegador, não falha? */
export function ehCancelamentoDoNavegador(motivo: unknown): boolean {
  if (motivo == null) return false
  if (typeof DOMException !== "undefined" && motivo instanceof DOMException && motivo.name === "AbortError") {
    return true
  }
  const nome = motivo instanceof Error ? motivo.name : ""
  if (nome === "AbortError") return true
  const mensagem = motivo instanceof Error
    ? motivo.message
    : typeof motivo === "string"
      ? motivo
      : String(motivo)
  return PADROES_DE_CANCELAMENTO.some((p) => p.test(mensagem))
}
